import { X, Sparkles, AlertTriangle, Zap } from 'lucide-react'
import { Button } from '@/common/ui/button'
import type { ChatAiDraftPayload } from '../../../sse/types'
import type { AiAnswerMode } from '../../../api/services'

interface AiDraftSuggestionProps {
	draft: ChatAiDraftPayload
	onUse: () => void
	onIgnore: () => void
	aiAnswerMode?: AiAnswerMode
}

export function AiDraftSuggestion({
	draft,
	onUse,
	onIgnore,
	aiAnswerMode,
}: AiDraftSuggestionProps) {
	const confidencePct = draft.confidence
		? Math.round(draft.confidence * 100)
		: 0
	const isEscalated = draft.action === 'escalate'
	const isAutoMode = aiAnswerMode === 'AUTO'

	return (
		<div
			className={`mx-4 mb-2 rounded-lg border p-3 ${
				isEscalated
					? 'border-orange-200 bg-orange-50/70'
					: 'border-blue-200 bg-blue-50/70'
			}`}
		>
			<div className="mb-2 flex items-center justify-between">
				<div className="flex flex-wrap items-center gap-2">
					{isEscalated ? (
						<AlertTriangle className="h-4 w-4 text-orange-500" />
					) : (
						<Sparkles className="h-4 w-4 text-blue-500" />
					)}
					<span
						className={`text-xs font-medium ${
							isEscalated ? 'text-orange-600' : 'text-blue-600'
						}`}
					>
						{isEscalated ? '🚨 แนะนำ Escalate' : 'AI แนะนำการตอบ'} (
						{draft.intent}) - มั่นใจ {confidencePct}%
					</span>
					{isAutoMode && (
						<span className="inline-flex items-center gap-1 rounded bg-emerald-100 px-1.5 py-0.5 text-xs font-medium text-emerald-700">
							<Zap className="h-3 w-3" />
							AUTO — ส่งแล้ว
						</span>
					)}
				</div>
				<Button
					variant="ghost"
					size="icon"
					className={`h-6 w-6 ${
						isEscalated
							? 'text-orange-400 hover:text-orange-600'
							: 'text-blue-400 hover:text-blue-600'
					}`}
					onClick={onIgnore}
				>
					<X className="h-3.5 w-3.5" />
				</Button>
			</div>

			<p
				className={`mb-3 text-sm leading-relaxed ${
					isEscalated ? 'text-orange-800' : 'text-blue-800'
				}`}
			>
				{draft.draftText || '—'}
			</p>

			<div className="flex gap-2">
				<Button
					variant="default"
					size="sm"
					className={`flex-1 text-xs ${
						isEscalated
							? 'bg-orange-500 hover:bg-orange-600'
							: 'bg-blue-500 hover:bg-blue-600'
					}`}
					onClick={onUse}
				>
					ใช้ข้อความนี้
				</Button>
				<Button
					variant="outline"
					size="sm"
					className="flex-1 text-xs"
					onClick={onIgnore}
				>
					ข้าม / ไม่ใช้
				</Button>
			</div>
		</div>
	)
}
